import { useMutation } from '@tanstack/react-query';

export default function useDeleteOrganizationMember() {
  const token = (document.getElementsByName('csrf-token')[0] as HTMLMetaElement).content;
  return useMutation({
    mutationFn: async (params: { staff_id: number }) => {
      const response = await fetch(`/agent/api/organization_users/${params.staff_id}`, {
        method: 'DELETE',
        headers: {
          'Content-Type': 'application/json',
          Accept: 'application/json',
          'X-CSRF-Token': token,
        },
      });

      if (!response.ok) {
        const errorData = await response.json();
        throw new Error(errorData.error);
      }

      return await response.json();
    },
  });
}
